import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContractType } from '../../../shared/models/contract/contract-type.model';
import { CommonService } from '../../../shared/service/common.service';
import { ValidationUiService } from '../../../shared/service/ui/validation-ui';
declare function maskingDob(): any;

@Component({
  selector: 'app-primary-insured-dob',
  templateUrl: './primary-insured-dob.component.html'
})
export class PrimaryInsuredDobComponent implements OnInit {
  @Output() submitAnswer: EventEmitter<string> = new EventEmitter<string>();
  @Input() contractType: ContractType;

  DOB: string | null;

  constructor(
    public validationUiService: ValidationUiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    maskingDob();
    this.DOB = this.commonService.customDateFormat(this.contractType?.policyHolder.personType[0]?.birthDate, 'dd/MM/yyyy');
  }

  onSubmitAnswer(date: any) {
    this.submitAnswer.emit(date);
  }
}
